import { FormInput } from "@/components/bnp-ui";
import { Checkbox } from "@mantine/core";
import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";

const StepOne = ({
  setValue,
  control,
  selectedButton,
  setSelectedButton,
  amountPayable,
  setAmountPayable,
  isChecked,
  setIsChecked,
}: any) => {
  const basePrice = 30000;
  const [customAmount, setCustomAmount] = useState("21");
  const [discount, setDiscount] = useState(0);

  const calculateDiscount = (amount: any) => {
    const numericAmount = parseInt(amount);

    if (numericAmount <= 5) return 5;
    if (numericAmount <= 10) return 10;
    if (numericAmount <= 15) return 15;
    if (numericAmount <= 20) return 20;
    return 25;
  };

  const calculateTotal = (amount: any) => {
    const numericAmount = parseInt(amount);
    const discountPercent = calculateDiscount(amount);
    const discountMultiplier = (100 - discountPercent) / 100;
    return numericAmount * basePrice * discountMultiplier;
  };

  const handleAmountSelection = (amount: any) => {
    setSelectedButton(amount);

    if (amount !== ">20") {
      setCustomAmount("");
      const discountPercent = calculateDiscount(amount);
      setDiscount(discountPercent);
      setAmountPayable(calculateTotal(amount));
      setValue("amount", amountPayable);
    } else {
      setDiscount(25);
      setAmountPayable(calculateTotal(customAmount || "21"));
      setValue("amount", amountPayable);
    }
  };

  const handleCustomAmountChange = (e: any) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) {
      setCustomAmount(value);

      if (value && parseInt(value) > 20) {
        const discountPercent = calculateDiscount(value);
        setDiscount(discountPercent);
        setAmountPayable(calculateTotal(value));
      }
    }
  };

  useEffect(() => {
    handleAmountSelection(selectedButton);
  }, []);

  const formatNaira = (amount: any) => {
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(amount)
      .replace("NGN", "N");
  };

  return (
    <div className="w-full max-w-3xl mx-auto p-4">
      <div className="w-full mb-6">
        <p className="text-sm font-semibold text-main-900 mb-2">
          Amount per inspection
        </p>
        <div className="flex items-center text-gray-500 p-4 cursor-not-allowed bg-gray-100 w-full h-[52px] rounded-lg">
          <p>₦30,000</p>
        </div>
      </div>

      <div className="w-full mb-6">
        <p className="text-sm font-semibold text-main-900 mb-2">
          Amount to buy
        </p>
        <div className="flex gap-2 mb-6">
          {["5", "10", "15", "20", ">20"].map((amount) => (
            <button
              key={amount}
              className={`flex justify-center items-center h-14 w-14 sm:w-20 rounded-lg border transition-colors ease-linear delay-200 ${
                selectedButton === amount
                  ? "border-bnp-cyan bg-white"
                  : "border-soft-200 bg-white"
              }`}
              onClick={() => handleAmountSelection(amount)}
            >
              {amount}
            </button>
          ))}
        </div>

        {selectedButton === ">20" && (
          <div className="w-full mb-6">
            <p className="text-sm font-semibold text-main-900 mb-2">
              How many do you want to buy?
            </p>

            <Controller
              name="amount"
              control={control}
              render={({ field: { onChange, onBlur, value } }) => (
                <FormInput
                  name="amount"
                  type="text"
                  value={customAmount}
                  onChange={handleCustomAmountChange}
                  placeholder="must be >20"
                  className="w-full outline-none"
                />
              )}
            />
          </div>
        )}

        <div className="p-4 flex flex-col gap-3 w-full border border-bnp-cyan bg-gray-50 rounded-lg">
          <div className="w-full flex justify-between">
            <p className="text-gray-600">Discount</p>
            <p className="text-gray-800 font-medium">{discount}%</p>
          </div>
          <div className="w-full flex justify-between">
            <p className="text-gray-600">Amount payable</p>
            <p className="text-gray-800 font-medium">
              {formatNaira(amountPayable)}
            </p>
          </div>
          <div className="w-full flex justify-between">
            <p className="text-gray-600">Validity period</p>
            <p className="text-gray-800 font-medium">365 days</p>
          </div>
        </div>
      </div>

      <div className="flex items-start mt-4">
        <Checkbox
          type="checkbox"
          color="cyan"
          id="terms"
          className="mt-1 h-4 w-4 text-blue-500 border-gray-300 rounded"
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
        />
        <label htmlFor="terms" className="ml-2 text-sm text-gray-700">
          I hereby attest to the rules of Live Inspection Services as managed by
          FindNigeriaProperties.com
        </label>
      </div>
    </div>
  );
};

export default StepOne;
